(function () {
  var TITLE_SELECTOR =
    '.product-item--wl-collection .product-item__title .text-animation--underline';

  var MAX_LINES = 2;
  var RESIZE_DELAY = 120;

  var resizeTimer = null;
  var scheduled = false;

  function getFullTitle(element) {
    if (!element.dataset.wlFullTitle) {
      element.dataset.wlFullTitle = element.textContent.trim();
    }

    return element.dataset.wlFullTitle;
  }

  function countRenderedLines(element, text) {
    element.textContent = text;
    element.classList.add('wl-title-measuring');

    var range = document.createRange();
    range.selectNodeContents(element);

    var rects = Array.prototype.slice
      .call(range.getClientRects())
      .filter(function (rect) {
        return rect.width > 0 && rect.height > 0;
      });

    var lineTops = [];

    rects.forEach(function (rect) {
      var top = Math.round(rect.top);

      var alreadyCounted = lineTops.some(function (existingTop) {
        return Math.abs(existingTop - top) <= 1;
      });

      if (!alreadyCounted) {
        lineTops.push(top);
      }
    });

    range.detach();
    element.classList.remove('wl-title-measuring');

    return lineTops.length;
  }

  function fitsInTwoLines(element, text) {
    return countRenderedLines(element, text) <= MAX_LINES;
  }

  function fitTitle(element) {
    var fullTitle = getFullTitle(element);
    var titleLink = element.closest('.product-item__title');

    if (titleLink) {
      titleLink.setAttribute('aria-label', fullTitle);
      titleLink.setAttribute('title', fullTitle);
    }

    element.textContent = fullTitle;

    if (fitsInTwoLines(element, fullTitle)) {
      return;
    }

    var words = fullTitle.split(/\s+/).filter(Boolean);

    if (words.length <= 1) {
      return;
    }

    var low = 1;
    var high = words.length - 1;
    var best = words[0] + '...';

    while (low <= high) {
      var middle = Math.floor((low + high) / 2);

      var candidate =
        words.slice(0, middle).join(' ') + '...';

      if (fitsInTwoLines(element, candidate)) {
        best = candidate;
        low = middle + 1;
      } else {
        high = middle - 1;
      }
    }

    element.textContent = best;
  }

  function fitAllTitles(root) {
    root = root || document;

    var titles;

    if (root.matches && root.matches(TITLE_SELECTOR)) {
      titles = [root];
    } else if (root.querySelectorAll) {
      titles = Array.prototype.slice.call(
        root.querySelectorAll(TITLE_SELECTOR)
      );
    } else {
      titles = [];
    }

    titles.forEach(fitTitle);
  }

  function scheduleFit(root) {
    root = root || document;

    if (scheduled) {
      return;
    }

    scheduled = true;

    window.requestAnimationFrame(function () {
      scheduled = false;
      fitAllTitles(root);
    });
  }

  function initialize() {
    scheduleFit(document);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        scheduleFit(document);
      });
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(function () {
        scheduleFit(document);
      }, RESIZE_DELAY);
    });

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        scheduleFit(event.target);
      }
    );

    var observer = new MutationObserver(function (mutations) {
      var collectionCardsChanged = mutations.some(
        function (mutation) {
          return Array.prototype.slice
            .call(mutation.addedNodes)
            .some(function (node) {
              if (!(node instanceof Element)) {
                return false;
              }

              return (
                node.matches('.product-item--wl-collection') ||
                node.querySelector('.product-item--wl-collection')
              );
            });
        }
      );

      if (collectionCardsChanged) {
        scheduleFit(document);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();